import React from 'react';
import {
  Accordion,
  AccordionSummary,
  NativeSelect,
  AccordionDetails,
  Typography,
  Grid,
  Paper,
  Input,
  Button,
  Checkbox
} from '@material-ui/core';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import InputMask from 'react-input-mask';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import Loading from '../../../components/Loading';

import PhoneMask from '../components/PhoneMask';

import useStyles from './style';

function Register({
  inputs,
  handleInputChange,
  handleInputCheckboxChange,
  getLoading,
  getEstados,
  getMunicipios,
  getJornadas,
  getPerfis,
  onSubmit,
  getErros,
  setErros,
  findCep,
  inputsBlocked,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Cadastrar Colaborador"
        back="/app/colaboradores"
        submit={onSubmit}
        submitText="Cadastrar"
      />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {getLoading ? (
            <Loading />
          ) : (
            <form onSubmit={onSubmit}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Dados Pessoais</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome Completo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome completo"
                          value={inputs.nome}
                          name="nome"
                          onBlur={(event) =>
                            getErros.includes('Nome') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Nome';
                              }),
                            )
                          }
                          error={getErros.includes('Nome')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label} style={{ marginLeft: '3%' }}>
                        Status
                      </label>
                      <Paper style={{ marginLeft: '3%' }} className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.status}
                          name="status"
                          onChange={handleInputChange}
                          error={getErros.includes('Status')}
                          onBlur={(event) =>
                            getErros.includes('Status') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Status';
                              }),
                            )
                          }
                        >
                          <option value="Pendente">Pendente</option>
                          <option value="Contratado">Contratado</option>
                          <option value="Experiencia">Experiência</option>
                          <option value="Estagiario">Estagiário</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Cpf</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="999.999.999-99"
                          value={inputs.cpf}
                          name="cpf"
                          onBlur={(event) =>
                            getErros.includes('Cpf') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Cpf';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={handleInputChange}
                          autocomplete="off"
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="CPF"
                              name="cpf"
                              error={getErros.includes('Cpf')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Perfil</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.perfilId}
                          name="perfilId"
                          onChange={handleInputChange}
                          error={getErros.includes('PerfilId')}
                          onBlur={(event) =>
                            getErros.includes('PerfilId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'PerfilId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getPerfis.map((perfil) => (
                            <option key={perfil.perfilId} value={perfil.perfilId}>
                              {perfil.perfil}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome da mãe</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome da mãe"
                          value={inputs.nomeMae}
                          inputProps={{
                            maxLength: 100,
                          }}
                          autocomplete="off"
                          error={getErros.includes('NomeMae')}
                          onBlur={(event) =>
                            getErros.includes('NomeMae') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomeMae';
                              }),
                            )
                          }
                          name="nomeMae"
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Rg</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="RG"
                          name="rg"
                          error={getErros.includes('Rg')}
                          inputProps={{
                            maxLength: 15,
                          }}
                          autocomplete="false"
                          disabled={false}
                          value={inputs.rg}
                          onBlur={(event) =>
                            getErros.includes('Rg') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Rg';
                              }),
                            )
                          }
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Estado Civil</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.estadoCivil}
                          name="estadoCivil"
                          onChange={handleInputChange}
                          error={getErros.includes('EstadoCivil')}
                          onBlur={(event) =>
                            getErros.includes('EstadoCivil') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EstadoCivil';
                              }),
                            )
                          }
                        >
                          <option value="FaltaPreencher">FALTA PREENCHER</option>
                          <option value="Solteiro">Solteiro(a)</option>
                          <option value="Casado">Casado(a)</option>
                          <option value="Viuvo">Viuvo(a)</option>
                          <option value="Separado">Separado(a)</option>
                          <option value="Outros">Outros</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Nome do pai</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome do pai"
                          value={inputs.nomePai}
                          name="nomePai"
                          inputProps={{
                            maxLength: 100,
                          }}
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('NomePai') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomePai';
                              }),
                            )
                          }
                          error={getErros.includes('NomePai')}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Data de Nascimento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="99/99/9999"
                          value={inputs.dataNascimento}
                          name="dataNascimento"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('DataNascimento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'DataNascimento';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={handleInputChange}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              name="dataNascimento"
                              placeholder="DATA DE NASCIMENTO"
                              error={getErros.includes('DataNascimento')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Nome do conjuge</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome do conjuge"
                          value={inputs.nomeConjuge}
                          name="nomeConjuge"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('NomeConjuge') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomeConjuge';
                              }),
                            )
                          }
                          error={getErros.includes('NomeConjuge')}
                          inputProps={{ maxLength: 100 }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Endereço</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Cep</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="99.999-999"
                          value={inputs.cep}
                          name="cep"
                          disabled={false}
                          onChange={handleInputChange}
                          onBlur={(event) => {
                            if (getErros.includes('Cep')) {
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Cep';
                                }),
                              );
                            }
                            findCep(inputs.cep);
                          }}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="CEP"
                              name="cep"
                              inputProps={{
                                autocomplete: 'off',
                              }}
                              error={getErros.includes('Cep')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Logradouro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Logradouro"
                          name="logradouro"
                          readOnly={inputsBlocked.includes('logradouro')}
                          autocomplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                          onBlur={(event) =>
                            getErros.includes('Logradouro') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Logradouro';
                              }),
                            )
                          }
                          error={getErros.includes('Logradouro')}
                          value={inputs.logradouro}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Bairro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Bairro"
                          name="bairro"
                          readOnly={inputsBlocked.includes('bairro')}
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Bairro') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Bairro';
                              }),
                            )
                          }
                          error={getErros.includes('Bairro')}
                          value={inputs.bairro}
                          inputProps={{
                            maxLength: 50,
                          }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Estado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.estadoId}
                          name="estadoId"
                          disabled={inputsBlocked.includes('estado')}
                          onChange={handleInputChange}
                          error={getErros.includes('EstadoId')}
                          onBlur={(event) =>
                            getErros.includes('EstadoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EstadoId';
                              }),
                            )
                          }
                        >
                          <option value="">Selecione o estado</option>
                          {getEstados.map((estado) => (
                            <option key={estado.estadoId} value={estado.estadoId}>
                              {estado.estado}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Número</label>
                      <Paper className={classes.small} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          placeholder="Número"
                          name="numero"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Numero') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Numero';
                              }),
                            )
                          }
                          error={getErros.includes('Numero')}
                          inputProps={{
                            maxLength: 6,
                          }}
                          value={inputs.numero}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={4}>
                      <label className={classes.label}>Complemento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Complemento"
                          name="complemento"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Complemento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Complemento';
                              }),
                            )
                          }
                          error={getErros.includes('Complemento')}
                          inputProps={{
                            maxLength: 50,
                          }}
                          value={inputs.complemento}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Município</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.municipioId}
                          name="municipioId"
                          onChange={handleInputChange}
                          error={getErros.includes('MunicipioId')}
                          onBlur={(event) =>
                            getErros.includes('MunicipioId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'MunicipioId';
                              }),
                            )
                          }
                          disabled={inputsBlocked.includes('municipio')}
                        >
                          <option>Selecione o município</option>
                          {getMunicipios.map((municipio) => (
                            <option key={municipio.municipioId} value={municipio.municipioId}>
                              {municipio.municipio}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Contato</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Telefone 1</label>
                      <Paper className={classes.medium} elevation={0}>
                        <PhoneMask
                          value={inputs.telefone1}
                          name="telefone1"
                          autocomplete="off"
                          error={getErros.includes('Telefone1')}
                          onBlur={(event) =>
                            getErros.includes('Telefone1') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Telefone1';
                              }),
                            )
                          }
                          className={classes.input}
                          placeholder="Telefone 1"
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Telefone 2</label>
                      <Paper className={classes.medium} elevation={0}>
                        <PhoneMask
                          value={inputs.telefone2}
                          name="telefone2"
                          autocomplete="off"
                          className={classes.input}
                          placeholder="Telefone 2"
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputEmail }}
                          placeholder="E-mail"
                          name="email"
                          type="email"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Email') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Email';
                              }),
                            )
                          }
                          error={getErros.includes('Email')}
                          value={inputs.email}
                          inputProps={{
                            maxLength: 100,
                          }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Dados Profissionais</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Pis</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputMask
                          mask="999.99999.99-9"
                          value={inputs.pis}
                          name="pis"
                          disabled={false}
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Pis') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Pis';
                              }),
                            )
                          }
                          onChange={handleInputChange}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="PIS"
                              error={getErros.includes('Pis')}
                              inputProps={{
                                autocomplete: 'off',
                              }}
                              name="pis"
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Número da Ctps</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                          error={getErros.includes('CtpsNumero')}
                          autocomplete="off"
                          placeholder="NÚMERO DA CTPS"
                          onBlur={(event) =>
                            getErros.includes('CtpsNumero') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'CtpsNumero';
                              }),
                            )
                          }
                          inputProps={{ maxLength: 5 }}
                          name="ctpsNumero"
                          value={inputs.ctpsNumero}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Série da Ctps</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          value={inputs.ctpsSerie}
                          autocomplete="off"
                          onChange={handleInputChange}
                          error={getErros.includes('CtpsSerie')}
                          onBlur={(event) =>
                            getErros.includes('CtpsSerie') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'CtpsSerie';
                              }),
                            )
                          }
                          placeholder="SÉRIE DA CTPS"
                          inputProps={{ maxLength: 10 }}
                          name="ctpsSerie"
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label} style={{ marginLeft: '3%' }}>
                        Data de Admissão
                      </label>
                      <Paper className={classes.small} style={{ marginLeft: '3%' }} elevation={0}>
                        <InputMask
                          mask="99/99/9999"
                          value={inputs.dataAdmissao}
                          name="dataAdmissao"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('DataAdmissao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'DataAdmissao';
                              }),
                            )
                          }
                          disabled={false}
                          onChange={handleInputChange}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="DATA DE ADMISSÃO"
                              error={getErros.includes('DataAdmissao')}
                              inputProps={{
                                autocomplete: 'off',
                              }}
                              name="dataAdmissao"
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label}>Contrato Experiencia</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.contratoExperiencia}
                          name="contratoExperiencia"
                          onChange={handleInputChange}
                          error={getErros.includes('ContratoExperiencia')}
                          onBlur={(event) =>
                            getErros.includes('ContratoExperiencia') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ContratoExperiencia';
                              }),
                            )
                          }
                        >
                          <option value="FaltaPreencher">FALTA PREENCHER</option>
                          <option value="TrintaDias">30 dias</option>
                          <option value="QuarentaECincoDias">45 dias</option>
                          <option value="SessentaDias">60 dias</option>
                          <option value="NoventaDias">90 dias</option>
                          <option value="SemContrato">Sem Contrato</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label} style={{ marginLeft: '3%' }}>
                        Grau de instrução
                      </label>
                      <Paper style={{ marginLeft: '3%' }} className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.grauInstrucao}
                          name="grauInstrucao"
                          onChange={handleInputChange}
                          error={getErros.includes('GrauInstrucao')}
                          onBlur={(event) =>
                            getErros.includes('GrauInstrucao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'GrauInstrucao';
                              }),
                            )
                          }
                        >
                          <option value="FaltaPreencher">FALTA PREENCHER</option>
                          <option value="SegundoGrauIncompleto">Segundo grau incompleto</option>
                          <option value="SegundoGrauCompleto">Segundo grau completo</option>
                          <option value="SuperiorIncompleto">Superior Incompleto</option>
                          <option value="SuperiorCompleto">Superior Completo</option>
                          <option value="PosGraduadoIncompleto">Pôs Graduado Incompleto</option>
                          <option value="PosGraduadoCompleto">Pôs Graduado Completo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label}>
                        Quantidade de filhos menores de 14 anos
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="QUANTIDADE DE FILHOS MENORES DE 14 ANOS"
                          value={inputs.qtdFilhosMenor14Anos}
                          type="text"
                          min="0"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('QtdFilhosMenor14Anos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'QtdFilhosMenor14Anos';
                              }),
                            )
                          }
                          error={getErros.includes('QtdFilhosMenor14Anos')}
                          name="qtdFilhosMenor14Anos"
                          inputProps={{ maxLength: 2 }}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label style={{ marginLeft: '3%' }} className={classes.label}>
                        Salário-Família
                      </label>
                      <Paper style={{ marginLeft: '3%' }} className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.salarioFamilia}
                          name="salarioFamilia"
                          onChange={handleInputChange}
                          error={getErros.includes('SalarioFamilia')}
                          onBlur={(event) =>
                            getErros.includes('SalarioFamilia') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'SalarioFamilia';
                              }),
                            )
                          }
                        >
                          {inputs.qtdFilhosMenor14Anos > 0 ? (
                            <>
                              <option value="FaltaPreencher">FALTA PREENCHER</option>
                              <option value="Sim">Sim</option>
                              <option value="Nao">Não</option>
                            </>
                          ) : (
                            <>
                              <option value="FaltaPreencher">FALTA PREENCHER</option>
                              <option value="Nao">Não</option>
                            </>
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label}>Receber vale transporte</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.receberValeTransporte}
                          name="receberValeTransporte"
                          onChange={handleInputChange}
                          error={getErros.includes('ReceberValeTransporte')}
                          onBlur={(event) =>
                            getErros.includes('ReceberValeTransporte') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ReceberValeTransporte';
                              }),
                            )
                          }
                        >
                          <option value="FaltaPreencher">FALTA PREENCHER</option>
                          <option value="Sim">Sim</option>
                          <option value="Nao">Não</option>
                          <option value="AjudaDeCusto">Ajuda de Custo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Jornada de trabalho</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.jornadaTrabalhoId}
                          name="jornadaTrabalhoId"
                          onChange={handleInputChange}
                          error={getErros.includes('JornadaTrabalhoId')}
                          onBlur={(event) =>
                            getErros.includes('JornadaTrabalhoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'JornadaTrabalhoId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getJornadas.map((jornada) => (
                            <option
                              key={jornada.jornadaTrabalhoId}
                              value={jornada.jornadaTrabalhoId}
                            >
                              {jornada.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label}>
                        Salário
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={inputs.valorSalario}
                          currencySymbol="R$"
                          placeholder="SALÁRIO"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          digitGroupSeparator="."
                          name="valorSalario"
                          error={getErros.includes('ValorSalario')}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('ValorSalario') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ValorSalario';
                              }),
                            )
                          }
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Dados para Acesso</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label}>Login</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Login"
                          name="login"
                          autoComplete="off"
                          error={getErros.includes('Login')}
                          onBlur={(event) =>
                            getErros.includes('Login') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Login';
                              }),
                            )
                          }
                          value={inputs.login}
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6} className={classes.grid2}>
                      <label className={classes.label} style={{ marginLeft: '3%' }}>
                        Senha
                      </label>
                      <Paper style={{ marginLeft: '3%' }} className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="SENHA"
                          value={inputs.senha}
                          name="senha"
                          autocomplete="off"
                          error={getErros.includes('Senha')}
                          onBlur={(event) =>
                            getErros.includes('Senha') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Senha';
                              }),
                            )
                          }
                          inputProps={{ minLength: 8, maxLength: 100 }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div className={classes.divButton}>
                <Button variant="contained" type="submit" className={classes.button}>
                  Cadastrar
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Register;
